import { AxiosResponse } from 'axios'
import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { $axios } from './axios'
import { UserType } from '../../server/models/User'

export const createUser = (body: {
    name: string
    email: string
}): Promise<AxiosResponse<UserType>> => {
  return $axios.post('/user', body)
}

export const getUsers = (): Promise<AxiosResponse<UserType[]>> => {
  return $axios.get('/user')
}

export const useUsersQuery = (
  options?: Omit<UseQueryOptions<UserType[], Error>, 'queryKey' | 'queryFn'>
) => {
  return useQuery<UserType[], Error>({
    queryKey: ['users'],
    queryFn: async () => {
      const res = await getUsers()
      return res.data
    },
    staleTime: 10 * 60 * 1000, // 10 minutes - liberal caching
    gcTime: 60 * 60 * 1000, // 1 hour - keep in cache for a long time
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    ...options
  })
}
